<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    [attr.fill]="fillColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0 5.75239C0 2.57214 2.68286 0 6 0C9.31714 0 12 2.57214 12 5.75239C12 9.17917 8.21143 13.9043 6.66 15.704C6.31714 16.0985 5.69143 16.0985 5.34857 15.704C3.78857 13.9043 0 9.17917 0 5.75239ZM3.5 6.68275C3.5 8.15474 4.62 9.34939 6 9.34939C7.38 9.34939 8.5 8.15474 8.5 6.68275C8.5 5.21076 7.38 4.01611 6 4.01611C4.62 4.01611 3.5 5.21076 3.5 6.68275Z"
  />
</svg>
